var $59aa54360d27f339$exports = {};
$59aa54360d27f339$exports = {
    "removeButtonLabel": `Odstr\xe1ni\u{165}`,
    "removeDescription": `Ak chcete odstr\xe1ni\u{165} zna\u{10D}ku, stla\u{10D}te kl\xe1ves Delete.`
};


export {$59aa54360d27f339$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
